export default __webpack_public_path__ + "static/media/brazil-map-mensageiros.bde25ffd.png";